import { createAction, createAsyncAction } from 'typesafe-actions';
import localForage from 'localforage';
import { tokenUrl, tokensParameterBody, refreshParameterBody } from '../../config';
import { User, Token, List, Response } from './types';
import { getUsername, getMyListFromLocal, formatMyList, authFetch, unauthFetch } from '../../utils';

export const getUserInfoAction = createAsyncAction(
  'user/USER_INFO_REQUEST',
  'user/USER_INFO_SUCCESS',
  'user/USER_INFO_FAILURE'
)<void, User[], Error>();

export const getTokensFromCodeAction = createAsyncAction(
  'user/GET_TOKENS_FROM_CODE_REQUEST',
  'user/GET_TOKENS_FROM_CODE_SUCCESS',
  'user/GET_TOKENS_FROM_CODE_FAILURE'
)<void, Token, Error>();

export const setTokensInLSAction = createAsyncAction(
  'user/SET_TOKENS_IN_LS_REQUEST',
  'user/SET_TOKENS_IN_LS_SUCCESS',
  'user/SET_TOKENS_IN_LS_FAILURE'
)<void, Token, Error>();

export const getTokensFromLSAction = createAsyncAction(
  'user/GET_TOKENS_FROM_LS_REQUEST',
  'user/GET_TOKENS_FROM_LS_SUCCESS',
  'user/GET_TOKENS_FROM_LS_FAILURE'
)<void, Token, Error>();

export const refreshTokensAction = createAsyncAction(
  'user/REFRESH_TOKENS_REQUEST',
  'user/REFRESH_TOKENS_SUCCESS',
  'user/REFRESH_TOKENS_FAILURE'
)<void, Token, Error>();


export const syncUserAction = createAsyncAction(
  'syncUser/SYNC_REQUEST',
  'syncUser/SYNC_SUCCESS',
  'syncUser/SYNC_FAILURE'
)<void, any, Error>();

export const getUserParkInfoAction = createAsyncAction(
  'getUserPark/GET_REQUEST',
  'getUserPark/GET_SUCCESS',
  'getUserPark/GET_FAILURE'
)<void, Response, Error>();

export const addToUserListAction = createAsyncAction(
  'user/addToList/ADD_REQUEST',
  'user/addToList/ADD_SUCCESS',
  'user/addToList/ADD_FAILURE'
)<void, Response, Error>();

export const removeFromUserListAction = createAsyncAction(
  'user/removeFromList/REMOVE_REQUEST',
  'user/removeFromList/REMOVE_SUCCESS',
  'user/removeFromList/REMOVE_FAILURE'
)<void, Response, Error>();

export const addNotesAction = createAsyncAction(
  'notes/ADD_NOTES_REQUEST',
  'notes/ADD_NOTES_SUCCESS',
  'notes/ADD_NOTES_FAILURE'
)<void, Response, Error>();

export const updateDateAction = createAsyncAction(
  'date/UPDATE_DATE_REQUEST',
  'date/UPDATE_DATE_SUCCESS',
  'date/UPDATE_DATE_FAILURE'
)<void, Response, Error>();

export const getAllListAction = createAsyncAction(
  'users/GET_ALL_LIST_REQUEST',
  'users/GET_ALL_LIST_SUCCESS',
  'users/GET_ALL_LIST_FAILURE'
)<void, Response, Error>();

export const setRefresh = createAction('users/SET_REFRESH', resolve =>
  (refresh: boolean) => resolve(refresh)
);

export const signoutAction = createAction('users/SIGN_OUT', resolve =>
  () => resolve()
);

export const getAllList = (tokens: Token, type: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getAllListAction.request());
      const result: any = await authFetch(tokens, {
        url: `users/${type}/parks`,
        param: {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
        },
      }, dispatch);
      if (result && result!.error) {
        dispatch(getAllListAction.failure(new Error(result!.error)));
        return;
      }
      // @ts-ignore
      if (result && result.status === 404) {
        dispatch(getAllListAction.failure(new Error('Not found.')));
        return;
      }
      // @ts-ignore
      if (result && result.status !== 200) {
        dispatch(getAllListAction.failure(new Error('We could not sync you.')));
        return;
      }
      // @ts-ignore
      const res = await result.json();
      dispatch(getAllListAction.success({
        parks: res.parks,
        type,
      }));
    });
  };
};

export const updateDate = (tokens: Token, parkData: any) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(updateDateAction.request());
      if (!tokens.id_token) {
        dispatch(updateDateAction.failure(new Error('You do not have permissions to add a place.')));
      }
      const result: any = await authFetch(tokens, {
        url: `users/parks/${parkData.park_code}/date`,
        param: {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            ...parkData,
          }),
        },
      }, dispatch);
      if (result && result!.error) {
        dispatch(getAllListAction.failure(new Error(result!.error)));
        return;
      }
      // @ts-ignore
      if (result && result.status === 404) {
        dispatch(updateDateAction.failure(new Error('Not updated')));
      }
      // if (result.status !== 200) {
      //   dispatch(updateDateAction.failure(new Error('We could not update your notes.')));
      // }
      // @ts-ignore
      const res = await result.json()
      dispatch(updateDateAction.success(res));
    });
  };
};

export const addNotes = (tokens: Token, parkData: any) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(addNotesAction.request());
      if (!tokens.id_token) {
        dispatch(addNotesAction.failure(new Error('You do not have permissions to add a place.')));
      }
      const result: any = await authFetch(tokens, {
        url: `notes/parks/${parkData.park_code}`,
        param: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            ...parkData,
          }),
        },
      }, dispatch);
      if (result && result!.error) {
        dispatch(getAllListAction.failure(new Error(result!.error)));
        return;
      }
      // @ts-ignore
      if (result && result.status === 404) {
        dispatch(addNotesAction.failure(new Error('Not updated')));
        return;
      }
      // if (result.status !== 200) {
      //   dispatch(addNotesAction.failure(new Error('We could not update your notes.')));
      // }
      // @ts-ignore
      const res = await result.json()
      dispatch(addNotesAction.success(res));
    });
  };
};

export const addToUserList = (tokens: Token, parkData: any, listType: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(addToUserListAction.request());
      if (!tokens.id_token) {
        dispatch(addToUserListAction.failure(new Error('You do not have permissions to add a place.')));
      }
      const result: any = await authFetch(tokens, {
        url: `users/${listType}/${parkData.park_code}`,
        param: {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            ...parkData,
          }),
        },
      }, dispatch);
      if (result && result!.error) {
        dispatch(getAllListAction.failure(new Error(result!.error)));
        return;
      }
      // update user info and userParks
      if (result && result.status === 404) {
        dispatch(addToUserListAction.failure(new Error('We could not add to list.')));
        return;
      }
      if (result && result.status !== 200) {
        dispatch(addToUserListAction.failure(new Error('We could not add to list.')));
        return;
      }
      const res = await result.json()
      dispatch(addToUserListAction.success({ ...res, parkData, listType}));
    });
  };
};

export const removeFromUserList = (tokens: Token, parkCode: string, listType: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(removeFromUserListAction.request());
      if (!tokens.id_token) {
        dispatch(removeFromUserListAction.failure(new Error('You do not have permissions to remove a place.')));
      }
      const result: any = await authFetch(tokens, {
        url: `users/${listType}/${parkCode}`,
        param: {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
        },
      }, dispatch);
      if (result && result!.error) {
        dispatch(getAllListAction.failure(new Error(result!.error)));
        return;
      }

      if (result && result.status === 404) {
        dispatch(removeFromUserListAction.failure(new Error('We could not sync you.')));
        return;
      }
      // update user info and userParks
      if (result && result.status !== 200) {
        dispatch(removeFromUserListAction.failure(new Error('We could not sync you.')));
        return;
      }
      const res = await result.json();
      dispatch(removeFromUserListAction.success({ ...res, parkCode, listType }));
    });
  };
};

export const getUserParkInfo = (tokens: Token, parkCode: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getUserParkInfoAction.request());
      if (!tokens.id_token) {
        dispatch(getUserParkInfoAction.failure(new Error('You do not have permissions to add a place.')));
      }
      const result: any = await authFetch(tokens, {
        url: `users/parks/${parkCode}`,
        param: {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
        },
      }, dispatch);

      if (result && result!.error) {
        dispatch(getAllListAction.failure(new Error(result!.error)));
        return;
      }
      if (result && result.status === 404) {
        dispatch(getUserParkInfoAction.failure(new Error('Not found.')));
        return;
      }
      if (result && result.status !== 200) {
        dispatch(getUserParkInfoAction.failure(new Error('We could not sync you.')));
        return;
      }
      const res = await result.json();
      dispatch(getUserParkInfoAction.success(res));
    });
  };
};

export const syncUser = (tokens: Token, placeData: any) => {
  return async (dispatch: any) => {
    dispatch(syncUserAction.request());
    if (!tokens.id_token) {
      return dispatch(syncUserAction.failure(new Error('You do not have permissions to add a place.')));
    }
    const result: any = await authFetch(tokens, {
      url: `users`,
      param: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          parks: placeData,
        }),
      },
    }, dispatch);

    if (result && result!.error) {
      dispatch(getAllListAction.failure(new Error(result!.error)));
      return;
    }
    
    if (result && result.status !== 200) {
      return dispatch(syncUserAction.failure(new Error('We could not sync you.')));
    }
    // const place: AddPlaceResponse = await result.json();
    await localForage.removeItem('myList');
    console.log('local==================deleted', localForage.getItem('myList'))
    return dispatch(syncUserAction.success());
  };
};

const firstTimeSync = async (tokens: Token, parks: any) => {
  const result = await authFetch(tokens, {
    url: 'users',
    param: {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
      body: JSON.stringify({ parks }),
    },
  });
  return result;
};

const getCurrentUserInfo = async (tokens: Token) => {
  const result = await authFetch(tokens, {
    url: 'users/self', 
    param: {}
  });
  return result;
};

const getListByType = async (tokens: Token, type: string, username: string, nextKeyString?: string) => {
  const key = `${nextKeyString ? `?nextkey=${nextKeyString}` : ''}`;
  if (type === 'photos') {
    const result = await unauthFetch(`photos/users/${username}${key}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
    return result;
  }
  const result = await authFetch(tokens, {
    url: `users/${username}/${type}${key}`,
    param: {},
  });
  return result;
};

export const getTokensFromCode = (code: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getTokensFromCodeAction.request());
      const result = await fetch(tokenUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `${tokensParameterBody}&code=${code}`,
      });
      if (result.status !== 200) {
        return dispatch(getTokensFromCodeAction.failure(new Error('Code expired')));
      }
      const tokens: any = await result.json();
      const todayTime = new Date();
      tokens.expired_at = todayTime.setTime(todayTime.getTime() + (60*100));
      await localForage.setItem('tokens', tokens);
      dispatch(getTokensFromCodeAction.success(tokens));
      await formatMyList();
      dispatch(getUserInfoAction.request());
      dispatch(getListAction.request());
      let myList = {};
      try {
        myList = await getMyListFromLocal();
      } catch (e) {
        console.log(e);
      }
      const username = getUsername(tokens.id_token);
      await firstTimeSync(tokens, myList);
      // TODO
      // save list per user in local storage;
      dispatch(syncUserAction.success());
      await localForage.removeItem('myList');
      console.log('local==================deleted', localForage.getItem('myList'))
      const userInfo: any = await getCurrentUserInfo(tokens);
      dispatch(getUserInfoAction.success(await userInfo!.json()));
      const type = 'visited';
      const list: any = await getListByType(tokens, type, username);
      const payload = { ...await list!.json(), type };
      dispatch(getListAction.success(payload));
    });
  }
};

export const refreshTokens = (refresh: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(refreshTokensAction.request());
      const result = await fetch(tokenUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `${refreshParameterBody}&refresh_token=${refresh}`,
      });
      if (result.status !== 200) {
        return dispatch(refreshTokensAction.failure(new Error('Token expired')));
      }
      const tokens: any = await result.json();
      const todayTime = new Date();
      tokens.refresh_token = refresh;
      tokens.expired_at = todayTime.setTime(todayTime.getTime() + (60*100));
      await localForage.setItem('tokens', tokens);
      return dispatch(refreshTokensAction.success(tokens));
    });
  }
};

export const getTokens = () => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getTokensFromLSAction.request());
      const tokens: any = await localForage.getItem('tokens');
      return dispatch(getTokensFromLSAction.success(tokens));
    });
  }
};

export const getListAction = createAsyncAction(
  'user/LIST_REQUEST',
  'user/LIST_SUCCESS',
  'user/LIST_FAILURE'
)<void, List, Error>();

export const getUserInfo = (tokens: Token) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getUserInfoAction.request());
      const userInfo: any = await getCurrentUserInfo(tokens);
      const username = getUsername(tokens.id_token);
      dispatch(getUserInfoAction.success(await userInfo!.json()));
      const type = 'visited';
      const list: any = await getListByType(tokens, type, username);
      const payload = { ...await list!.json(), type };
      dispatch(getListAction.success(payload));
    });
  }
};

export const getList = (tokens: Token, type: string, nextKey?: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getListAction.request());
      const username = getUsername(tokens.id_token);
      const result: any = await getListByType(tokens, type, username, nextKey);
      const payload = { ...await result!.json(), type };
      dispatch(getListAction.success({
        ...payload, type, hasNextKey: !!nextKey,
      }));
    });
  }
};

export const setTokensWithDispatch = (tokens: Token, dispatch: any) => {
  if (dispatch) {
    dispatch(setTokensInLSAction.request());
    dispatch(setTokensInLSAction.success(tokens));
  }
};

export const setTokens = (tokens: Token) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(setTokensInLSAction.request());
      return dispatch(setTokensInLSAction.success(tokens));
    });
  }
};
